import { createContext } from "react"

import { ScopedConfigurationsResponse } from "@tfg/types/types/communication-studio/configurations.types"
import { StylingParameters } from "@tfg/types/types/communication-studio/styling-parameters.types"

import {
  DEFAULT_CONFIGURATIONS,
  DEFAULT_STYLING_PARAMETERS,
} from "../../config"

type StylingParametersContextType = {
  stylingParameters: StylingParameters
  configurations: ScopedConfigurationsResponse
}

export const StylingParametersContext =
  createContext<StylingParametersContextType>({
    stylingParameters: DEFAULT_STYLING_PARAMETERS,
    configurations: DEFAULT_CONFIGURATIONS,
  })
type StylingParametersProviderProps = {
  children: React.ReactNode
  stylingParameters: StylingParameters
  configurations: ScopedConfigurationsResponse
}
export const StylingParametersProvider = ({
  children,
  stylingParameters,
  configurations,
}: StylingParametersProviderProps) => {
  return (
    <StylingParametersContext.Provider
      value={{ stylingParameters, configurations }}
    >
      {children}
    </StylingParametersContext.Provider>
  )
}
